import {Component, Input} from '@angular/core';
import {FilterIndicatorComponent} from '../filter-indicator/filter-indicator.component';

@Component({
  selector: 'ostso-filter-indicators-bar',
  standalone: true,
    imports: [
        FilterIndicatorComponent,
    ],
  templateUrl: './filter-indicators-bar.component.html',
  styleUrls: ['../filter-indicator/filter-indicator.component.scss', './filter-indicators-bar.component.scss']
})
export class FilterIndicatorsBarComponent {
  @Input() filter: any | null = null;
  protected readonly Array = Array;
}
